import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { EstimateModal } from '../components/EstimateModal/EstimateModal';
type EstimateContextValue = {
  openEstimate: (service?: string) => void;
};
const EstimateContext = createContext<EstimateContextValue | null>(null);
export function EstimateProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const [initialService, setInitialService] = useState<string | undefined>();
  const openEstimate = useCallback((service?: string) => {
    setInitialService(service);
    setOpen(true);
  }, []);
  const close = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({
    openEstimate
  }), [openEstimate]);
  return <EstimateContext.Provider value={value} data-id="element-392" data-mp="1jjrle58ch4ad">
      {children}
      <EstimateModal open={open} initialService={initialService} onClose={close} data-id="element-393" data-mp="1oht24jiasrio" />
    </EstimateContext.Provider>;
}
export function useEstimate() {
  const ctx = useContext(EstimateContext);
  if (!ctx) throw new Error('useEstimate must be used inside EstimateProvider');
  return ctx;
}